export const MULTI_MESH_TRANSFORM_SAME_BODY_WARNING =
  "Transform and rotate are only available when selected visual meshes belong to the same body.";

export function resolveVisualMeshTransformTargets(bodies, selectedMeshIds) {
  const meshIds = [...(selectedMeshIds || [])].filter(Boolean).map(String);
  if (meshIds.length === 0) {
    return {
      canTransform: false,
      targets: [],
      reason: "",
    };
  }

  const targetsByKey = new Map();
  const bodyUuids = new Set();
  const foundMeshIds = new Set();

  Object.values(bodies || {}).forEach((body) => {
    if (!body?.uuid || !Array.isArray(body.geoms)) return;
    body.geoms.forEach((geom) => {
      if (!geom?.uuid || geom.visualOnly !== true || !geom.mesh) return;
      const meshUuid = String(geom.mesh);
      if (!meshIds.includes(meshUuid)) return;
      const bodyUuid = String(body.uuid);
      foundMeshIds.add(meshUuid);
      bodyUuids.add(bodyUuid);
      targetsByKey.set(`${bodyUuid}:${geom.uuid}`, {
        bodyUuid,
        geomId: String(geom.uuid),
        meshUuid,
      });
    });
  });

  const targets = [...targetsByKey.values()];
  if (foundMeshIds.size !== meshIds.length || targets.length === 0) {
    return {
      canTransform: false,
      targets,
      reason: MULTI_MESH_TRANSFORM_SAME_BODY_WARNING,
    };
  }

  if (bodyUuids.size !== 1) {
    return {
      canTransform: false,
      targets,
      reason: MULTI_MESH_TRANSFORM_SAME_BODY_WARNING,
    };
  }

  return {
    canTransform: true,
    targets,
    reason: "",
  };
}
